import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Документы (подзаписи)',
      docM: 'Записи',
      fields: {
        id: '#',
        docHId: 'Документ',
        idpos: 'Id позиции',
        numdoc: 'Номер документа',
        num_goods: 'Номер товара',
        product_cost: 'Цена',
        product_description: 'Описание товара',
        product_tax: 'Налог',
        uit_code: 'Код маркировки',
        uitu_code: 'Код агрегата',
        accepted: 'Принят',
      },
    },
  },
};
